const actions = {
  // Role Templates Actions
  GET_ROLE_TEMPLATES: 'RBAC/ROLE_TEMPLATES/GET_ROLE_TEMPLATES',
  GET_ROLE_TEMPLATES_SUCCESS: 'RBAC/ROLE_TEMPLATES/GET_ROLE_TEMPLATES_SUCCESS',
  GET_ROLE_TEMPLATES_ERROR: 'RBAC/ROLE_TEMPLATES/GET_ROLE_TEMPLATES_ERROR',
  CREATE_ROLE_TEMPLATE: 'RBAC/ROLE_TEMPLATES/CREATE_ROLE_TEMPLATE',
  CREATE_ROLE_TEMPLATE_SUCCESS: 'RBAC/ROLE_TEMPLATES/CREATE_ROLE_TEMPLATE_SUCCESS',
  CREATE_ROLE_TEMPLATE_ERROR: 'RBAC/ROLE_TEMPLATES/CREATE_ROLE_TEMPLATE_ERROR',
  UPDATE_ROLE_TEMPLATE: 'RBAC/ROLE_TEMPLATES/UPDATE_ROLE_TEMPLATE',
  UPDATE_ROLE_TEMPLATE_SUCCESS: 'RBAC/ROLE_TEMPLATES/UPDATE_ROLE_TEMPLATE_SUCCESS',
  UPDATE_ROLE_TEMPLATE_ERROR: 'RBAC/ROLE_TEMPLATES/UPDATE_ROLE_TEMPLATE_ERROR',
  DELETE_ROLE_TEMPLATE: 'RBAC/ROLE_TEMPLATES/DELETE_ROLE_TEMPLATE',
  DELETE_ROLE_TEMPLATE_SUCCESS: 'RBAC/ROLE_TEMPLATES/DELETE_ROLE_TEMPLATE_SUCCESS',
  DELETE_ROLE_TEMPLATE_ERROR: 'RBAC/ROLE_TEMPLATES/DELETE_ROLE_TEMPLATE_ERROR',
  CLEAR_ROLE_TEMPLATES_ERROR: 'RBAC/ROLE_TEMPLATES/CLEAR_ROLE_TEMPLATES_ERROR',

  // Action Creators
  getRoleTemplates: () => ({
    type: actions.GET_ROLE_TEMPLATES,
  }),
  getRoleTemplatesSuccess: (roleTemplates) => ({
    type: actions.GET_ROLE_TEMPLATES_SUCCESS,
    roleTemplates,
  }),
  getRoleTemplatesError: (error) => ({
    type: actions.GET_ROLE_TEMPLATES_ERROR,
    error,
  }),
  createRoleTemplate: (templateData) => ({
    type: actions.CREATE_ROLE_TEMPLATE,
    templateData,
  }),
  createRoleTemplateSuccess: (roleTemplate) => ({
    type: actions.CREATE_ROLE_TEMPLATE_SUCCESS,
    roleTemplate,
  }),
  createRoleTemplateError: (error) => ({
    type: actions.CREATE_ROLE_TEMPLATE_ERROR,
    error,
  }),
  updateRoleTemplate: (templateId, templateData) => ({
    type: actions.UPDATE_ROLE_TEMPLATE,
    templateId,
    templateData,
  }),
  updateRoleTemplateSuccess: (roleTemplate) => ({
    type: actions.UPDATE_ROLE_TEMPLATE_SUCCESS,
    roleTemplate,
  }),
  updateRoleTemplateError: (error) => ({
    type: actions.UPDATE_ROLE_TEMPLATE_ERROR,
    error,
  }),
  deleteRoleTemplate: (templateId) => ({
    type: actions.DELETE_ROLE_TEMPLATE,
    templateId,
  }),
  deleteRoleTemplateSuccess: (templateId) => ({
    type: actions.DELETE_ROLE_TEMPLATE_SUCCESS,
    templateId,
  }),
  deleteRoleTemplateError: (error) => ({
    type: actions.DELETE_ROLE_TEMPLATE_ERROR,
    error,
  }),
  clearRoleTemplatesError: () => ({
    type: actions.CLEAR_ROLE_TEMPLATES_ERROR,
  }),
};

export default actions;
